import React, { FormEvent } from "react";
import { useIntl } from "react-intl";
import styles from "./SearchBox.module.css";

interface ISearchBox {
  disabled?: boolean;
  value?: string | null;
  onChange?: (text: string) => void;
}

const SearchBox = ({ value, onChange, disabled }: ISearchBox) => {
  const intl = useIntl();

  const searchTranslation = intl.messages["GLOBAL.SEARCH"] as string;

  const onChangeHandler = (e: FormEvent<HTMLInputElement>) => {
    var value = e.currentTarget.value;
    if (onChange) onChange(value ?? "");
  };

  return (
    <div
      className={`d-flex align-items-center position-relative ${value &&
        styles.inputWithValueMobile}`}
    >
      <span className={`px-sm-0 px-2 fa fa-search ${styles.searchIcon}`}></span>
      <input
        autoComplete="off"
        className={styles.input}
        type="text"
        name="search"
        placeholder={searchTranslation}
        value={value ?? ""}
        onChange={onChangeHandler}
        disabled={disabled}
        readOnly={disabled}
      />
    </div>
  );
};

export default SearchBox;
